<template>
    <div>
        <v-alert
        v-if="tipo == 'sucesso'"
        transition="expand-transition"
        border="left"
        text
        dismissible
        type="success"
        >
            {{ texto }}
        </v-alert>

        <v-alert
        v-if="tipo == 'erro'"
        transition="expand-transition"
        border="left"
        text
        dismissible
        type="error"
        >
            {{ texto }}
        </v-alert>
    </div>
</template>

<script>
export default {
    props: {
        tipo: String,
        texto: String,
    },
};
</script>